import { createContext, useContext, useRef } from "react";
import { motion, useReducedMotion, useScroll, useTransform } from "framer-motion";
import { useIsDesktop } from "../hooks/useMedia";

const SceneCtx = createContext(null);

export const ParallaxScene = ({ as: Tag = "section", offset, className = "", children, ...rest }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: offset || ["start start", "end start"] });
  const reduce = useReducedMotion();
  const desktop = useIsDesktop();
  return (
    <SceneCtx.Provider value={{ progress: scrollYProgress, enabled: !reduce && desktop }}>
      <Tag ref={ref} className={className} {...rest}>
        {children}
      </Tag>
    </SceneCtx.Provider>
  );
};

export const ParallaxLayer = ({ y = 0, scale = 1, fade, className = "", style, children, ...rest }) => {
  const { progress, enabled } = useContext(SceneCtx);
  const [y0, y1] = Array.isArray(y) ? y : [0, y];
  const ty = useTransform(progress, [0, 1], enabled ? [y0, y1] : [0, 0]);
  const ts = useTransform(progress, [0, 1], [1, enabled ? scale : 1]);
  const to = useTransform(progress, [0.05, 0.42], [1, enabled && fade != null ? fade : 1]);
  return (
    <motion.div style={{ y: ty, scale: ts, opacity: to, willChange: enabled ? "transform" : undefined, ...style }} className={className} {...rest}>
      {children}
    </motion.div>
  );
};
